// product-form.js

customElements.define(
  'product-form',
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      // Carrito (cart-drawer o cart-notification)
      this.cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');

      if (document.querySelector('cart-drawer'))
        this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(
          '.product-form__error-message'
        );

      this.errorMessageWrapper.toggleAttribute(
        'hidden',
        !errorMessage
      );

      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent =
          window.variantStrings.addToCart;
      }
    }

    // Evento principal del submit
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.section)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // Error
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });

            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          // Redirección si no hay carrito
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;

          // Actualizar carrito
          this.cart.renderContents(response);

          // 🔥 Re-asignar listeners a botones e inputs del carrito
          this.initCartEvents();

          // Actualizar icono / contador
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty'))
            this.cart.classList.remove('is-empty');

          if (!this.error)
            this.submitButton.removeAttribute('aria-disabled');

          this.querySelector('.loading__spinner')?.classList.add('hidden');
        });
    }

    // 🔥 Inicializa los eventos del carrito: eliminar y cambiar cantidad
    initCartEvents() {
      // Botones eliminar (tachito)
      const deleteButtons = this.cart.querySelectorAll('.delete-btn');
      deleteButtons.forEach((btn) => {
        btn.onclick = () => {
          const id = btn.dataset.id;
          fetch(`${routes.cart_change_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, quantity: 0 }),
          })
            .then((res) => res.json())
            .then((res) => {
              this.cart.renderContents(res);
              this.initCartEvents(); // re-asignar eventos
            });
        };
      });

      // Inputs de cantidad
      const quantityInputs = this.cart.querySelectorAll('.cart-quantity');
      quantityInputs.forEach((input) => {
        input.onchange = () => {
          const id = input.dataset.id;
          let qty = parseInt(input.value);
          if (isNaN(qty) || qty < 1) qty = 1;

          fetch(`${routes.cart_change_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, quantity: qty }),
          })
            .then((res) => res.json())
            .then((res) => {
              this.cart.renderContents(res);
              this.initCartEvents(); // re-asignar eventos
            });
        };
      });
    }
  }
);

